import React, { Component } from 'react';
import ApiManager from './apiManager/index';
import { connect } from 'react-redux';
import { setTranslationsAction, setTokenAction, setConfigAction } from './store/Layout/actions';
import AppBox from './components/Fragments/AppBox';
import ErrorModal from './components/Fragments/ErrorModal';
import Loading from './components/Fragments/Loading';
import { trans } from './helpers/index';

class Layout extends Component {

    constructor( props ){
        super( props );

        this.state = {
            showErrorModal: false,
            appRedirect: false
        };

        this.updateParentState = this.updateParentState.bind( this );

    }

    updateParentState( newState ){
        this.setState( newState );
    }

    componentDidMount(){

        ApiManager.getRequest({}, '/csrf-token').then(( resolve ) => {
            this.props.setTokenAction( resolve.data );
        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });

        ApiManager.getTranslations().then(( resolve ) => {
            this.props.setTranslationsAction( resolve.data );
        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });

        ApiManager.getRequest({}, '/config').then(( resolve ) => {
            this.props.setConfigAction( resolve.data );
        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });

    }

    render(){

        if ( this.state.showErrorModal ) {

            return (
                <ErrorModal
                    title={trans(this.props.trans, 'error.modal.title' )}
                    description={trans( this.props.trans, 'error.modal.description' )}
                    action_text={trans( this.props.trans, 'error.modal.action_text' )}
                />
            );

        }

        if ( this.props.trans === '' || this.props.csrf_token === '' || this.props.config === '' ) {

            return(
                <Loading />
            );

        }

        return(
            <>
                <AppBox
                    trans={this.props.trans}
                    config={this.props.config}
                    parentState={this.state}
                    updateParentState={this.updateParentState}
                />
                {this.props.children}
            </>
        );

    }

}

const mapStateToProps = state => {

    return {
        trans: state.layout.trans,
        config: state.layout.config,
        csrf_token: state.layout.csrf_token
    };

};

const mapDispatchToProps = {
    setTranslationsAction,
    setTokenAction,
    setConfigAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Layout);